export default __webpack_public_path__ + "static/media/logob.93951b4c.png";